import { getLocale } from "../runtime";

const sv_decountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tyskland`
};

const decountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_decountry(inputs)
	return "deCountry";
};

export { decountry as "deCountry" };